<template>
  <v-app>
    <navigation v-if="loggedIn" :links="links" :user="user"/>

    <v-content>
      <v-container fluid >
        <v-layout justify-center align-center>
          <router-view/>
          <vue-progress-bar/>

          <v-snackbar
                  v-model="snackbar"
                  :color="color"
                  :timeout="timeout"
                  right
          >
            {{ text }}
            <v-btn dark
                   flat
                   @click="clearSnackbar"
            >X</v-btn>
          </v-snackbar>

        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import Navigation from './components/Navigation'
  import { mapGetters } from 'vuex'

  export default {
    name: 'App',
    components: {
      Navigation
    },
    created(){
      this.$store.dispatch('getUser')
    },
    data () {
      return {
        links: [
          {icon: 'dashboard', text: 'Sākums', route: '/dashboard', permission: ''},
          {icon: 'grain', text: 'Mazgāšanas', route: '/cleanings', permission: ''},
          {icon: 'layers', text: 'Konteineri', route: '/containers', permission: ''},
          {icon: 'local_shipping', text: 'Transports', route: '/vehicles', permission: ''},
          {icon: 'event_note', text: 'Kravas', route: '/cargos', permission: ''},
          {icon: 'business_center', text: 'Uzņēmumi', route: '/companies', permission: ''},
          {icon: 'assignment_ind', text: 'Lietotāji', route: '/users', permission: 'manage users' },
        ]
      }
    },
    computed: {
      ...mapGetters({
        loggedIn: 'loggedIn',
        user: 'user',
        snackbar: 'snackbar',
        color: 'snackbarColor',
        timeout: 'snackbarTimeout',
        text: 'snackbarText',
      }),
    },
    methods:{
      clearSnackbar(){
        this.$store.dispatch('clearSnackbar')
      }
    }
  }
</script>
